export const apiList = {
  baseUrl: 'https://reportapi.bluebetta.me/api/v1/',
  //baseUrl: 'http://localhost:8000/api/v1/',
  //baseUrl: 'http://139.162.7.138:8000/api/v1/',
  baseUrl909:'https://api.sport909.com/',
  //baseUrl909: "https://localhost:44356",
  loginApi: 'user/auth',
  eventMatchApi : 'event',
  eventMatchArrayApi : 'event/multiple',
  differentOddApi : 'different-odd/event-list',
  differentOddHistoryApi : 'different-odd/history',
  differentOddVouchersApi : 'different-odd/vouchers',
  allGoalResultApi : 'goal-result',
  companyApi : 'company',
  settingApi : 'setting',
  
  rejectVoucherApi : 'api/GoalsResult/cancel-voucher',
  editGoalResultApi :'api/GoalsResultEdit/goal-result-choice',
  backgroundStatusApi : 'api/GoalsResultEdit/fetch-update-status-result',
  eventReportApi : 'api/Report/by-event',
  mixReportApi : 'api/Report/by-mix',
  purchasedReportApi : 'api/Report/by-purchased',
  purchaseVoucherApi : 'api/Report/event-mix',
  gamblingLimitApi : 'api/Report/purchase-limit',
  reportByVoucherApi : 'api/Report/by-voucher',
  transactionApi : 'api/Report/by-date',
  winLoseReportApi : 'api/ByCollection/winLoseReport-v2',
  winLoseReportDetailsApi : 'api/ByCollection/winLoseReport-v2/vouchers',
  winLoseReportVoucherApi : 'api/ByCollection/getDetails',
  resultHubApi : 'goal-result/result-hub',
  liveEventControlApi : 'api/GoalsResult/result-with-odds',
  updateTaxPercentApi : 'api/GoalsResult/update-comm-percent',
  removeEventApi : 'api/GoalsResult',
  getVouchersApi : 'api/GoalsResult/get-voucher',
  getWithdrawalApi : 'api/Payment/get-deposite-payment',
  getDepositeApi : 'api/Payment/get-withdrawal-payment',
  processWithdrawalApi : 'api/Payment/withdrawals',
  processDepositeApi : 'api/Payment/deposite',
  bankAccountApi : 'api/Payment/account',
  getTransactionHistoryApi : 'api/Payment/payment-history',
  getTodayEventApi : 'api/Home/live-event',
  getLiveBettingApi : 'api/Betting/betting-report-with-date',
  getBetDetailsApi : 'api/LiveData/voucher-view-details',
  getSingleInsightApi : 'api/LiveData',

  getRawLeagueEventsApi : 'api/TblLeagues',
  getLeaguesApi : 'api/TblLeagues/dropdown-league-data',
  saveLeagueToBufferApi : 'api/TblLeagues/buffer-temp',
  saveMultipleSiteBettingsApi : 'api/Site/save-multiple-site-bettings',

  getBufferZoneEventsApi : 'api/TblLeagues/get-buffer-list',
  saveBufferZoneSelectionsApi : 'api/TblLeagues',
  updateOddsManual : 'apii/TblLeagues/"manual-odds-update',
  updateAllBufferHandicapsApi : 'api/TblLeagues/update-odds-365',
  updateEventHandicapApi : 'api/TblLeagues/fetch-odds-manual',
  saveEventHandicapApi : 'api/TblLeagues/event-manual',
  getStatusResponseApi : 'api/TblLeagues/fetch-update-status/buffer',
  getUserListApi : 'api/UserBalance/balance',
  getUserListWithDetailsApi : 'api/Report/users-with-balance',
  updateUserBalanceApi : 'api/UserBalance',
  resetPasswordApi : 'api/UserSetting/reset',
  userTransactionApi : 'api/UserBalance/GetTransactionForUser',
  userLockApi : 'api/UserSetting/lock',
  logTrailApi : 'log-trail',
  getOddHubApi : 'compare-odd/odds-hub',
  getOddHubMovementApi : 'compare-odd/odds-hub/movement',
  updateEventTimeApi : 'api/TblLeagues/event-time',

  getDashboardBettingApi : 'api/SmartReport/betting',
  getDashboardUserApi : 'api/SmartReport/top-users',

  getVoucherExplorerApi : 'api/SmartReport/voucher-info',
  getVoucherExplorerDetailsApi : 'api/SmartReport/voucher-info/details',
  getmixmax2Api : 'api/UserBalance/getMinMax2',
  updateminmaxApi : 'api/UserBalance/minmax'
};
